import { c as _c } from "react/compiler-runtime";
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { AnnualFeeContainer } from './AnnualFee.container';
import { ContentText } from './components/ContentText';
export function AnnualFee() {
  const $ = _c(2);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    annualFeeDetails
  } = t0;
  const t1 = `${annualFeeDetails}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <AnnualFeeContainer><ContentText>{t1}</ContentText></AnnualFeeContainer>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}